import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/instance";
import { endpoints } from "../../constants/endpoints";

export const showEmployeServices = createAsyncThunk(
    "showEmployeServices",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getEmployeServices(id))
            return response
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    allServices: []
}

const EmployeeServices = createSlice({
    initialState,
    name: "EmployeeServices",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(showEmployeServices.pending, (state, action) => {
            state.loading = true
        })

        builder.addCase(showEmployeServices.fulfilled, (state, action) => {
            state.loading = false
            state.allServices = action?.payload?.data?.data
        })

        builder.addCase(showEmployeServices.rejected, (state, action) => {
            state.loading = false
        })
    }
})

export const { } = EmployeeServices.actions
export default EmployeeServices.reducer